import { Tag, Tooltip } from 'antd';
import { FC } from 'react';
import { Alarm, Calendar2Check } from 'react-bootstrap-icons';
import { getDateFactory } from '../../../../common/utils';

interface Props {
  publishedAt: Date | null;
  isPublished: boolean;
}

export const PagePublishedAtTag: FC<Props> = ({ publishedAt, isPublished }) => {
  if (publishedAt) {
    if (isPublished) {
      return (
        <Tooltip title={ getDateFactory(publishedAt, 'August 16, 2018 08:02') }>
          <Tag color="success">Опубліковано&nbsp;<Calendar2Check/></Tag>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={ getDateFactory(publishedAt, 'August 16, 2018 08:02') }>
          <Tag color="gold">Очікує публікації&nbsp;<Alarm/></Tag>
        </Tooltip>
      );
    }
  } else {
    return <Tag>Не опубліковано</Tag>;
  }
};
